import React from 'react'
import Header from '../Header/header'
import AwardBanner from './award/AwardBanner'
import AwardImages from './award/AwardImages'
import { Helmet } from 'react-helmet-async'

const Award = () => {
    return (
        <div>
            <Helmet>  <title>Our Achievements - Sharva Clinic </title>
                <meta
                    name="description"
                    content="Delhi's reliable multispecialty clinic provides all-encompassing care with creativity, empathy, and exceptional proficiency."
                /></Helmet>
            <Header />
            <AwardBanner />
            <AwardImages />
        </div>
    )
}

export default Award
